export const getCustomizationsQuery = (depth = 2) => {
  const PLACEHOLDER_PATTERN = '{PLACEHOLDER}'
  const queryPattern = `customizations {
    ...ProductCustomizationFields
    ${PLACEHOLDER_PATTERN}
  }`
  return Array.from({ length: depth })
    .reduce((prev: string) => {
      return prev.replace(PLACEHOLDER_PATTERN, queryPattern)
    }, PLACEHOLDER_PATTERN)
    .replace(PLACEHOLDER_PATTERN, '')
}
